/**
 * The inbox card of a contact, from whichever inbox list holds it.
 *
 * `All` holds every chat that is not closed; a closed chat is only in `Closed` (loaded when that tab is first opened) and a blocked contact
 * only in `Blocked`. Looking in `All` alone lost the QR number of every closed chat. Returns the first card found, null when none is loaded.
 */
const CARD_LISTS = ["All", "Closed", "Blocked"];

export const findInboxCard = (recentData, contactId) => {
  if (!recentData || !contactId) return null;
  const id = String(contactId);
  for (const list of CARD_LISTS) {
    const cards = recentData[list];
    const card = Array.isArray(cards) ? cards.find((c) => String(c.contactId) === id) : null;
    if (card) return card;
  }
  return null;
};

export default findInboxCard;
